import { HTMLAttributes, PropsWithChildren } from "react";
import styled, { css } from "styled-components";
import { maxSmall } from "../../styles/tokens";

// TEXT

// STYLES
export const displayStyles = css`
  font-weight: 700;
  font-size: 3.75rem;
  line-height: 3.375rem;
  letter-spacing: 0.02em;

  @media ${maxSmall} {
    font-size: 3rem;
    line-height: 3.5rem;
  }
`;
export const Display = styled.h1`
  ${displayStyles};
`;

export const h1Styles = css`
  font-weight: 700;
  font-size: 3rem;
  line-height: 3.5rem;
  letter-spacing: 0.02em;

  @media ${maxSmall} {
    font-size: 2rem;
    line-height: 2.5rem;
  }
`;
export const H1 = styled.h1`
  ${h1Styles};
`;

export const h2Styles = css`
  font-weight: 700;
  font-size: 2rem;
  line-height: 2.5rem;
  letter-spacing: 0.02em;

  @media ${maxSmall} {
    font-size: 1.5rem;
    line-height: 2rem;
  }
`;
export const H2 = styled.h2`
  ${h2Styles};
`;

export const h3NormalStyles = css`
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 2rem;
  letter-spacing: 0.02em;

  @media ${maxSmall} {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
`;
export const H3Normal = styled.h3`
  ${h3NormalStyles};
`;

export const h3StrongStyles = css`
  font-weight: 700;
  font-size: 1.5rem;
  line-height: 2rem;
  letter-spacing: 0.02em;

  @media ${maxSmall} {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
`;
export const H3Strong = styled.h3`
  ${h3StrongStyles};
`;
export const h4Styles = css`
  font-weight: 700;
  font-size: 1.25rem;
  line-height: 1.75rem;
  letter-spacing: 2%;

  @media ${maxSmall} {
    font-size: 1.125rem;
    line-height: 1.625rem;
  }
`;
export const H4 = styled.h4`
  ${h4Styles};
`;

export const sectionStyles = css`
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.5rem;
  letter-spacing: 0.25rem;
  text-transform: uppercase;
`;
export const Section = styled.h3`
  ${sectionStyles};
`;

// DATA

// TYPES
export interface Props extends PropsWithChildren, HTMLAttributes<HTMLElement> {
  tag?:
    | "div"
    | "span"
    | "p"
    | "small"
    | "h1"
    | "h2"
    | "h3"
    | "h4"
    | "h5"
    | "h6";
  variant?:
    | "display"
    | "h1"
    | "h2"
    | "h3-normal"
    | "h3-strong"
    | "h4"
    | "section";
}

// CONSTANTS

// FUNCTIONS

// ASSETS
